import React, { useEffect, useContext, useState, useRef } from "react";
import { observer } from "mobx-react";

import "./cost-modal.scss";
import authStore from "../../stores/authStore";
import { Modal, Flex } from "../../components/index";
import agreeIcon from "../../images/inbox-agree.png";
import disagreeIcon from "../../images/inbox-disagree.png";
import tipsIcon from "../../images/inbox-tips.png";
import costPrice from "../../images/cost-price.png";

import { initWxPayCode, wxJsPay, fetchWxPayStatus } from "../../utils/wx_tools";
import {
  isMobile,
  isWx,
  copyToClipboard,
  getDecimalPart,
} from "../../utils/tools";

import { message } from "antd";
import QRCode from "qrcode";

// 查到的过期时间为2小时
const timeLimit = 1000 * 60 * 60 * 2;
function formatPrice(price) {
  const val = price / 100;
  if (val > 0 && val < 0.1) {
    // 小于0.1且大于0，显示两位小数
    return val.toFixed(2);
  } else {
    // 其它情况保留一位小数
    return val.toFixed(1);
  }
}

// 非新用户购买弹窗
const CostModal = () => {
  const {
    xy,
    xyText,
    shopId,
    fetchProductInfo,
    productInfo,
    fetchMemberInfo,
    dialog,
    setDialog,
  } = useContext(authStore);

  const [agree, setAgree] = useState<boolean>(true);
  const [valid, setValid] = useState<boolean>(true);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const visible = dialog.buyVip;
  const onCancel = () => setDialog("buyVip", false);

  const onClose = () => {
    onCancel();
  };

  const updatePayStatus = (data: { orderId: string }) => {
    fetchWxPayStatus(data.orderId).then(async () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      onCancel();
      fetchMemberInfo();
      message.success("支付成功！");
    });
  };

  const initCodeFn = () => {
    initWxPayCode(shopId).then(async (data: { codeUrl: string }) => {
      setTimeout(() => {
        setValid(false);
      }, timeLimit);
      setValid(true);
      const url = await QRCode.toDataURL(data.codeUrl, { margin: 0 });
      const dom = document.querySelector(".qr-code");
      if (dom) dom.setAttribute("src", url);

      if (timerRef.current) {
        clearInterval(timerRef.current);
      }

      timerRef.current = setInterval(() => {
        updatePayStatus(data);
      }, 2000);
    });
  };

  useEffect(() => {
    fetchProductInfo();
  }, []);

  useEffect(() => {
    if (productInfo.price) {
      initCodeFn();
    }

    // 清理副作用（组件卸载时）
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [visible, productInfo.price]);

  return (
    <Modal
      style={{
        padding: 0,
        backgroundColor: "unset",
        borderRadius: "10px",
      }}
      visible={visible}
      closeable={false}
      onCancel={onClose}
      closeText={""}
    >
      <div className="cost-modal">
        <div className="cost-modal__body">
          <div className="cost-modal__name">订阅「机器之心文章库」</div>
          {productInfo.price && (
            <div className="cost-modal__price">
              <div className="shop-name">机器之心文章库一年访问权限</div>
              <div className="price-num">
                <span className="text-style-1">￥</span>
                {Math.floor(productInfo.price / 100)}
                <span className="text-style-2">.</span>
                <span className="text-style-3">
                  {getDecimalPart(productInfo.price)}
                </span>
                <span className="text-style-4">/年</span>
              </div>
              <img className="price-bg" src={costPrice} alt="icon" />
            </div>
          )}
          {productInfo.final_price &&
            (isMobile() ? (
              isWx() ? (
                <div className="cost-modal__pay">
                  <div
                    className="cost-modal__btn"
                    onClick={() => {
                      if (agree) {
                        onCancel();
                        wxJsPay(shopId)
                          .then(async () => {
                            fetchMemberInfo();
                            message.success("支付成功！");
                          })
                          .catch(() => {
                            message.error("支付失败！");
                          });
                      } else {
                        message.open({
                          type: "error",
                          duration: 3,
                          className: "ant-toast",
                          content: xyText,
                        });
                      }
                    }}
                  >
                    立即订阅，支付￥{formatPrice(productInfo.final_price)}
                  </div>
                  <Flex justify="center" className="cost-tips">
                    <img
                      src={agree ? agreeIcon : disagreeIcon}
                      alt="agreeIcon"
                      onClick={() => setAgree(!agree)}
                    />
                    <div>
                      我已阅读并同意{" "}
                      <a href={xy} target="_blank">
                        《用户服务协议》
                      </a>
                    </div>
                  </Flex>
                </div>
              ) : (
                <div className="cost-modal__guide">
                  <p>复制链接前往微信端订阅会员</p>
                  <span>https://www.jiqizhixin.com/articles</span>
                  <div
                    onClick={() => {
                      copyToClipboard("https://www.jiqizhixin.com/articles");
                      message.success("复制成功!");
                    }}
                  >
                    点此复制链接
                  </div>
                </div>
              )
            ) : (
              <Flex
                justify="space-between"
                className="cost-modal__code"
                style={productInfo.desc ? {} : { marginBottom: "20px" }}
              >
                <div className="info">
                  <div className="info-price">
                    实付金额：
                    <span>￥{formatPrice(productInfo.final_price)}</span>
                  </div>
                  <p className="info-title">微信扫码支付，立即订阅</p>
                  <Flex justify="center" className="cost-tips">
                    <img
                      src={agree ? agreeIcon : disagreeIcon}
                      alt="agreeIcon"
                      onClick={() => setAgree(!agree)}
                    />
                    <div>
                      我已阅读并同意{" "}
                      <a href={xy} target="_blank">
                        《用户服务协议》
                      </a>
                    </div>
                  </Flex>
                </div>
                <div className="code">
                  {valid ? (
                    <img className="qr-code" src="" alt="code" />
                  ) : (
                    <div className="code-invalid" onClick={() => initCodeFn()}>
                      <p>二维码过期</p>
                      <div>刷新</div>
                    </div>
                  )}
                </div>
              </Flex>
            ))}
          {productInfo.desc && (
            <div className="cost-intro">
              <div className="cost-intro__title">
                <img src={tipsIcon} alt="tipsIcon" />
                权益详细说明
              </div>
              <div className="cost-intro__desc">
                {productInfo.desc
                  .split("\r\n")
                  .map((p: string, index: number) => (
                    <p key={index}>{p}</p>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default observer(CostModal);
